<template>
  <div class="index-style">
    <div class="jianjie-style">
      <div class=" clear">
        <div class="left">欢迎访问营口房地产交易服务平台</div>
        <div class="right" v-if="!userData.realName">
          <span @click="handleLogin"><i class="u-icon"></i>登录</span>
          <!-- <span @click="handleRegister">注册</span> -->
          <span @click="goMy">个人中心</span>
        </div>
        <div class="right" v-else>
          <span @click="goMy">个人中心</span>
          <span class="v-line">|</span>
          <span>{{ userData.realName }}</span>
          <span class="v-line">|</span>
          <span class="cursor" @click="logout">退出</span>
        </div>
      </div>
    </div>
    <div class="bg-style">
      <div  class="login-img">
        <img src="../assets/login_title.png" oncontextmenu="return false;" alt="">
      </div>
      <!-- <h1 class="login-title">营口房地产交易服务平台</h1>
      <h4 class="login-title h4">一站式房地产市场综合服务新平台</h4> -->
      <transition-group tag="div" name="list">
        <div
          v-for="(item, index) in bgImg"
          :key="item.id"
          v-show="index == current"
          class="bg-img"
          :style="{ backgroundImage: 'url(' + item.img + ')' }"
        ></div>
      </transition-group>
    </div>
    <div class="nav-style">
      <ul class="clear">
        <li v-for="(item, index) in navList" :key="index">
          <div class="nav-width" @click="handleClick(item)">
            <span class="nav-img" :style="{ background: bgColor[item.boptId] }">
              <img :src="img[item.boptId]" alt="" />
            </span>
            <p v-if="item.boptName=='资产处置(顶账房)'" class="nav-name">
              资产处置<span style="color:red">(顶账房)</span>
            </p>
            <p v-else class="nav-name">
              {{ item.boptName }}
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="foot-style">
      <div class="foot-cont">
        <div>
          <p>
            <span style="margin-right: 0">系统入口：</span
            ><span style="margin-left: 0;" class="yq-link" @click="wqClick">网签签约系统</span>
            <span class="yq-link" @click="cjClick">项目楼盘信息采集系统</span>
            <span class="bah-style">
              <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21080302000360"
                ><img src="../assets/bntb.png" /> 辽公网安备 21080302000360号 </a
              >
            </span>
          </p>
          <p>
            <span>主办单位：营口大成信息科技咨询有限公司</span>
            <span class="bah-style">
              工信部备案/许可证编号：
              <a href="https://beian.miit.gov.cn" target="_blank"
                >辽ICP备2021011132号</a
              >
            </span>
          </p>
          <!-- <p class="csjs-scjj">
            <span @click="gocsjj">城市介绍</span>| <span @click="goscjj">市场简介</span>
          </p> -->
          <p>
            <span> 电话：0417-3581115 / 0417-3851115</span>
            <span>地址：新联北大街99号</span>
            <span>邮箱：ykdcxxkj@163.com</span>
          </p>
          <p class="xx-bottom">
            <span> 服务支持单位：营口市自然资源事务中心</span>

            <span>技术支持：营口大成信息科技咨询有限公司</span>
          </p>
        </div>
        <div>
          <img class="gzh-img" src="../assets/gghlogo.jpg" alt="" />
          <div>扫描关注公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgColor: {
        1: "#6D63CE",
        2: "#D4C730",
        3: "#D98556",
        4: "#E04F45",
        5: "#2597D8",
        6: "#99CC66",
        7: "#336699",
        8: "#FF9900",
        9: "#339999",
        10: "#FFCC00",
        11: "#009966",
        12: "#FF6666",
        13: "#0066CC",
        14: "#336633",
        15: "#CC3366",
        16: "#CC3333",
      },
      current: "0",
      timer: null, //定时器
      img: {
        1: require("../assets/nav/spf.png"),
        2: require("../assets/nav/clf.png"),
        3: require("../assets/nav/zlfw.png"),
        4: require("../assets/nav/jjjg.png"),
        5: require("../assets/nav/xxgk.png"),
        6: require("../assets/nav/jzfw.png"),
        7: require("../assets/nav/chgs.png"),
        8: require("../assets/nav/pggs.png"),
        9: require("../assets/nav/zxsj.png"),
        10: require("../assets/nav/jzjc.png"),
        11: require("../assets/nav/zcfg.png"),
        12: require("../assets/nav/sfbz.png"),
        13: require("../assets/nav/bszn.png"),
        14: require("../assets/nav/zccz.png"),
        15: require("../assets/nav/csjj.png"),
        16: require("../assets/nav/scjj.png"),
      },
      navList: [],
      bgImg: [
        { id: 1, img: require("../assets/bg/101.jpg") },
        { id: 2, img: require("../assets/bg/102.jpg") },
        { id: 3, img: require("../assets/bg/103.jpg") },
        // { id: 1, img: require("../assets/bg/1.jpg") },
        // { id: 2, img: require("../assets/bg/2.jpg") },
        // { id: 3, img: require("../assets/bg/3.jpg") },
        // { id: 3, img: require("../assets/bg/3（1）.jpg") },
        // { id: 4, img: require("../assets/bg/71cf3bc79f3df8dcd100e1368341658b4710b912824e.png") },
        // { id: 4, img: require("../assets/bg/4.jpg") },
        // { id: 5, img: require("../assets/bg/5.jpg") },
        // { id: 6, img: require("../assets/bg/6.jpg") },
        // { id: 7, img: require("../assets/bg/7.jpg") },
        // { id: 8, img: require("../assets/bg/8.jpg") },
        // { id: 9, img: require("../assets/bg/9.jpg") },
        // { id: 10, img: require("../assets/bg/10.jpg") },
        // { id: 11, img: require("../assets/bg/11.jpg") },
        // { id: 12, img: require("../assets/bg/12.jpg") },
        // { id: 13, img: require("../assets/bg/13.jpg") },
        // { id: 14, img: require("../assets/bg/14.jpg") },
        // { id: 15, img: require("../assets/bg/15.jpg") },
        // { id: 16, img: require("../assets/bg/16.jpg") },
        // { id: 17, img: require("../assets/bg/17.jpg") },
        // { id: 18, img: require("../assets/bg/18.jpg") },
        // { id: 19, img: require("../assets/bg/19.jpg") },
        // { id: 20, img: require("../assets/bg/20.jpg") },
        // { id: 21, img: require("../assets/bg/21.jpg") },
        // { id: 22, img: require("../assets/bg/22.jpg") },
        // { id: 23, img: require("../assets/bg/23.jpg") }
      ],
    };
  },
  computed: {
    userData() {
      return this.$store.getters.getUserData;
    },
  },
  created() {
    this.getBigOpt();
    this.play();
  },
  methods: {
    wqClick() {
      // this.$store.commit("setClfHouse",item);
      // let routeUrl = this.$router.resolve({ path: "/clf/clfxq", });
      window.open("https://www.ykfdcjy.com/ContractManagement", "_blank");
    },
    cjClick() {
      // this.$store.commit("setClfHouse",item);
      // let routeUrl = this.$router.resolve({ path: "/clf/clfxq", });
      window.open("https://www.ykfdcjy.com/collectionsystem", "_blank");
    },
    logout() {
      this.$confirm("您确定要退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit("setUserData", {});
          this.$router.replace("/");
        })
        .catch(() => {});
    },
    getBigOpt() {
      var that = this;
      that
        .axios({
          method: "post",
          url: "/api/index/getBigOpt",
        })
        .then((res) => {
          // console.log("res:", res.data);
          res.data.push(
            {
              boptId: 15,
              boptName: "城市简介",
              boptSort: 15,
              boptStatus: 15,
              boptUrl: "/csjj",
            },
            {
              boptId: 16,
              boptName: "公司简介",
              boptSort: 16,
              boptStatus: 16,
              boptUrl: "/scjj",
            },
            {
              boptId: 11,
              boptName: "政策法规",
              boptSort: 11,
              boptStatus: 11,
              boptUrl: "/zcfg",
            },
            {
              boptId: 13,
              boptName: "操作指南",
              boptSort: 12,
              boptStatus: 13,
              boptUrl: "/bszn",
            },
            {
              boptId: 12,
              boptName: "收费标准",
              boptSort: 13,
              boptStatus: 12,
              boptUrl: "/sfbz",
            }

            // {
            //   boptId: 14,
            //   boptName: "资产处置",
            //   boptSort: 14,
            //   boptStatus: 14,
            //   boptUrl: "/zccz",
            // }
          );
          that.navList = res.data;
        });
    },
    handleClick(item) {
      this.$router.push({ path: item.boptUrl });
    },
    // 自动循环播放轮播图
    autoPlay() {
      this.current++;
      if (this.current === this.bgImg.length) {
        //当遍历到最后一张图片置零
        this.current = 0;
      }
    },
    // 定时器
    play() {
      this.timer = setInterval(this.autoPlay, 3000);
    },
    // 登录
    handleLogin() {
      this.$router.push("/login");
    },
    // 注册
    handleRegister() {
      this.$router.push("/register");
    },
    // 个人中心
    goMy() {
      if (this.userData.userId) {
        this.$router.push("/my");
      } else {
        this.$confirm("未登录，请确定是否登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
      }
    },
    // 市场简介
    goscjj() {
      this.$router.push("/scjj");
    },
    // 市场简介
    gocsjj() {
      this.$router.push("/csjj");
    },
  },
};
</script>
<style lang="less" scoped>
.index-style {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  // overflow: auto;
  font-family: "Microsoft YaHei", "Hiragino Sans GB", STHeiti, SimSun, Arial,
    "微软雅黑", arial, Tahoma, SimSun, sans-serif;
  .jianjie-style {
    width: 100%;
    background: #fff;
    // position: absolute;
    div.clear {
      width: 90%;
      margin: 0 auto;
      height: 40px;
      line-height: 40px;
      // text-align: right;
      // color: #fff;
      color: #000;
      font-size: 14px;
      span {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  .bg-style {
    position: relative;
    width: 100%;
    height: 520px;
  }
  .login-img{
    width: 100%;
    position: absolute;
    top: 140px;
    text-align: center;
    img{
     max-width: 100%;
    }
  }
  .login-title {
    position: absolute;
    color: #fff;
    width: 100%;
    text-align: center;
    top: 140px;
    font-size: 58px;
    font-family: "宋体";
    text-shadow: 2px 2px 4px #0066cc;
  }
  .h4 {
    font-size: 28px;
    top: 240px;
    // text-shadow: 2px 2px 2px rgb(155, 157, 160);
    text-shadow: 2px 2px 2px #0066cc;
  }
  .u-icon {
    width: 18px;
    height: 18px;
    display: inline-block;
    vertical-align: middle;
    background: url("../../static/img/xmzp-mn-36.png") no-repeat;
  }
  .bg-img {
    position: absolute;
    width: 100%;
    left: 0;
    z-index: -1;
    height: 520px;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .list-enter-active,
  .list-leave-active {
    transition: opacity 1s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
  }
  .nav-style {
    width: 1200px;
    min-height: calc(100% - 700px);
    margin: 0 auto;
    padding: 10px 0;
    ul {
      width: 100%;
      height: 100%;
    }
    ul li {
      float: left;
      width: 14%;
      text-align: center;
      margin: 10px auto;
    }
    .nav-width {
      display: inline-block;
      cursor: pointer;
      height: 96px;
      overflow: hidden;
    }
    .nav-img {
      display: inline-block;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      text-align: center;
    }
    .nav-img img {
      vertical-align: middle;
      height: 40px;
      margin-top: 10px;
    }
    .nav-name {
      margin-top: 8px;
      font-size: 18px;
      height: 28px;
      line-height: 28px;
      color: #464646;
    }
    .nav-width:hover .nav-name {
      font-weight: bold;
    }
  }

  .foot-style {
    width: 100%;
    height: 150px;
    background: #616e77;
    .foot-cont {
      width: 1200px;
      height: 150px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 13px;
      p {
        line-height: 30px;
        span {
          margin: 0 8px;
        }
      }
      .csjs-scjj {
        span {
          cursor: pointer;
        }
      }
      .gzh-img {
        width: 100px;
        height: 100px;
        margin-bottom: 5px;
      }
      .yq-link:hover {
        text-decoration: underline;
        cursor: pointer;
      }
      .bah-style a {
        color: #fff;
        text-decoration: none;
      }
      .bah-style:hover a {
        cursor: pointer;
        // color: #f60;
        text-decoration: underline;
      }
      img{
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue